/** Lightning (fx 'bolt'): an overhead cut and a bolt striking the target from the sky. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('bolt', (host) => ({
  skill: ({ src, tgt, tx, ty }) => {
    host.swingArc(src, 'overhead', '150,220,255');
    host.fx.push({ type: 'bolt', x: tx, y: ty, t: 0, life: 0.35, seed: R() * 999 });
    host.fx.push({ type: 'ring', x: tx, y: ty, t: 0, life: 0.4, r: 22, col: '150,220,255' });
    host.fx.push({
      type: 'star',
      x: tx,
      y: ty - 10 * host.tall(tgt),
      t: 0,
      life: 0.2,
      r: 18,
      col: '200,240,255',
    });
    host.burst(tx, ty - 8 * host.tall(tgt), 16, ['#bfe9ff', '#ffffff', '#6fc3ff'], 70, 30, 0.5);
    host.shake = Math.max(host.shake, 4);
    host.sfx.bolt();
  },
}));
